import { Route } from 'react-router';
import { Switch } from 'react-router-dom';
import { userHasDetergentsEnabledRedir } from '../core/auth';
import { viewPermissionRefs } from '../core/components/UserGroupPermissions';
import Detergents from '../views/detergents/containers/Detergents';
import DetergentsTemp from '../views/detergentsTemp/containers/Detergents';
import { usePermissionCheck } from '../core/hooks/usePermissionCheck';

const DetergentsRoute = () => {
  const hasPermission = usePermissionCheck(viewPermissionRefs.detergent_wip);
  return (
    <Switch>
      <Route path="/:site/detergents">{hasPermission ? <DetergentsTemp /> : <Detergents />}</Route>
    </Switch>
  );
};

export default userHasDetergentsEnabledRedir(DetergentsRoute);
